import { Status } from "../../models/Status";

export const SIGN_UP_STATUS = "SIGN_UP_STATUS";
export const SIGN_UP_USER = "SIGN_UP_USER";

export type IState = {
  status: Status;
  user: Record<string, unknown>;
};
